// extracted by mini-css-extract-plugin
export default {"wrapper":"Contact_wrapper__ItIye","container":"Contact_container__RHnRs","getInTouch":"Contact_getInTouch__VzDfx"};